import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import TextureHelper from "@DigitalCatalogue/Scripts/Infrastructure/TextureHelper";

@Component({ name: "FamilyList" })
export default class FamilyList extends Vue {
    public localizer: any = Localizer;
    public textureHelper: any = TextureHelper;
    public textureListData: any = {};
    public textures: any[] = [];
    public isLoading: boolean = false;
    public footerPages: any[] = [];
    public pageIndex: number = 0;
    public pageCount: number = 0;
    public paginatorIndex: number = 0;
    public paginatorCount: number = 0;
    public textureCount: number = 0;
    public page: number = 0;
    public marketingBanner: any = null;

    get routes() {
        return (<any>window).App.routes;
    }

    get encodedFilters(): any {
        return this.$store.getters["catalogueStore/encodedFilters"];
    }

    get isContentLoading(): any {
        return this.$store.getters["catalogueStore/isContentLoading"];
    }

    @Watch("encodedFilters") async onEncodedFiltersChanged(value: string, oldValue: string) {
        this.page = 0;
        await this.getData(value);
    }

    @Prop() readonly collection: string;
    @Prop() readonly isAuthenticated: boolean;

    public async created() {
        await this.getData(this.encodedFilters);
    }

    public async getData(encodedFilters: string) {
        this.$store.commit("catalogueStore/setIsContentLoading", true);

        this.textureListData = (await Axios.post(this.routes.DigitalCatalogue_Catalogue_GetTextureListData, { collectionName: this.collection, filters: encodedFilters, page: this.page })).data;
        this.textures = this.textureListData.textures;
        this.pageIndex = this.textureListData.pageIndex;
        this.pageCount = this.textureListData.pageCount;
        this.textureCount = this.textureListData.textureCount;
        this.marketingBanner = this.textureListData.marketingBanner;

        this.pagination();

        this.$store.commit("catalogueStore/setIsContentLoading", false);
    }

    public redirectLogin(e: any) {
        e.preventDefault();
        window.location.href = this.routes.Account_User_Login;
    }

    public async updateQueryParameters() {
        document.querySelector(".page").scrollIntoView({ behavior: "smooth", block: "start" });

        await this.getData(this.encodedFilters);
    }

    public goToPage(index: number) {
        this.page = index;
        this.updateQueryParameters();
    }

    public goToPrevPage() {
        if (this.pageIndex < 1) {
            return;
        }
        this.page = this.pageIndex - 1;
        this.updateQueryParameters();
    }

    public goToNextPage() {
        if (this.pageIndex >= this.pageCount - 1) {
            return;
        }
        this.page = this.pageIndex + 1;
        this.updateQueryParameters();
    }

    public pagination() {
        this.paginatorCount = Math.ceil(this.pageCount / 4);
        this.paginatorIndex = Math.trunc(this.pageIndex / 4);

        this.footerPages = [...Array(this.pageCount).keys()].slice(this.paginatorIndex * 4, (this.paginatorIndex + 1) * 4);
    }

    public goToPageSelector(type: string) {
        if (type === "plus") {
            this.goToPage(this.footerPages.slice(-1)[0] + 1);
        }

        if (type === "less") {
            this.goToPage(this.footerPages.slice(0)[0] - 1);
        }
    }

    public openInfoRequest() {
        this.$store.commit("infoRequestStore/setInfoRequestVisible", true);
    }
};